//--------------------------------------------------------------------//
//******************** agentLogsTab **********************************//
//--------------------------------------------------------------------//
// Lists an agent's run logs on the left; selecting one loads and
// displays its raw content on the right.
import agentLogsTemplateUrl from './agent-logs.template.html';

angular.module('agentsTableModule')

.directive('agentLogsTab', ['AgentLogsService', function (AgentLogsService) {
    return {
        restrict: 'E',
        scope: {
            agent: '='
        },
        controller: ['$scope', 'localizationService', function ($scope, localizationService) {
            const dictionary = localizationService.getDictionary('account_settings');
            $scope.translate = (word) => localizationService.translate(word, dictionary);

            $scope.logs = [];
            $scope.selectedLog = null;
            $scope.logContent = '';
            $scope.loadingList = false;
            $scope.loadingContent = false;

            const agentId = $scope.agent._id;

            // Fetches the log content for a selected log entry and displays it on the right.
            $scope.selectLog = async function (log) {
                if (!log || !agentId) return;
                $scope.selectedLog = log;
                $scope.logContent = '';
                $scope.loadingContent = true;
                $scope.$applyAsync();

                try {
                    const result = await AgentLogsService.getLog(agentId, log.name);
                    $scope.logContent = result.content || '';
                } catch (err) {
                    console.error('Failed to load log content:', err);
                } finally {
                    $scope.loadingContent = false;
                    $scope.$applyAsync();
                }
            };

            // Fetches the agent's log list. Keeps the current selection if it
            // still exists, otherwise auto-selects the newest entry.
            $scope.refreshLogs = async function () {
                if (!agentId || $scope.loadingList) return;
                $scope.loadingList = true;
                try {
                    $scope.logs = await AgentLogsService.getLogs(agentId) || [];
                    const stillExists = $scope.selectedLog &&
                        $scope.logs.some((log) => log.name === $scope.selectedLog.name);
                    if (!stillExists && $scope.logs.length) {
                        $scope.selectLog($scope.logs[0]);
                    }
                } catch (err) {
                    console.error('Failed to load agent logs:', err);
                } finally {
                    $scope.loadingList = false;
                    $scope.$applyAsync();
                }
            };
            $scope.refreshLogs();
        }],
        templateUrl: agentLogsTemplateUrl
    };
}]);
